export type TravelListStatus = "quotation_shared" | "submitted" | "policy_issued";

export type TravelListFilterOption = {
    value: string;
    label: string;
};

export type TravelListTab = {
    value: TravelListStatus;
    label: string;
};

export type TravelListTabFilterParams = {
    status_id?: number;
    sub_status_id?: number;
    from_date?: string;
    to_date?: string;
};

export type TravelListColumn = {
    key: string;
    label: string;
    sortable?: boolean;
};

export type TravelListAction = {
    key: string;
    label: string;
    icon: string;
};

export type TravelListRow = {
    id: number;
    customerName: string;
    destinations: string[];
    tripType: string;
    planName: string;
    sharedOn: string;
    submittedOn: string;
    issuedOn: string;
    policyNo: string;
    status: string;
    download_policy?: string;
    quotationUrl?: string;
};

export const TRAVEL_LIST_TABS: TravelListTab[] = [
    { value: "quotation_shared", label: "Quotation Shared" },
    { value: "submitted", label: "On Process" },
    { value: "policy_issued", label: "Issued" },
];

export const TRAVEL_LIST_DEFAULT_FILTER_PARAMS: Record<TravelListStatus, TravelListTabFilterParams> = {
    quotation_shared: {
        status_id: 1,
        sub_status_id: 1,
    },
    submitted: {
        status_id: 1,
        sub_status_id: 2,
    },
    policy_issued: {
        status_id: 3,
        sub_status_id: 4,
    },
};

export const TRAVEL_LIST_DATE_FILTERS: TravelListFilterOption[] = [
    { value: "cdr", label: "Custom Date Range" },
    { value: "mtd", label: "MTD" },
    { value: "all", label: "Till Today (All)" },
];

export const TRAVEL_LIST_COLUMNS: Record<TravelListStatus, TravelListColumn[]> = {
    quotation_shared: [
        { key: "customerName", label: "Customer Name" },
        { key: "tripDetails", label: "Trip Details" },
        { key: "planName", label: "Plan Name" },
        { key: "sharedOn", label: "Shared On", sortable: true },
        { key: "action", label: "Action" },
    ],
    submitted: [
        { key: "customerName", label: "Customer Name" },
        { key: "tripDetails", label: "Trip Details" },
        { key: "planName", label: "Plan Name" },
        { key: "sharedOn", label: "Shared on", sortable: true },
        { key: "status", label: "Status" },
        { key: "action", label: "Action" },
    ],
    policy_issued: [
        { key: "customerName", label: "Customer Name" },
        { key: "tripDetails", label: "Trip Details" },
        { key: "planName", label: "Plan Name" },
        { key: "issuedOn", label: "Issued on", sortable: true },
        { key: "action", label: "Action" },
    ],
};

export const TRAVEL_LIST_ACTIONS: Record<TravelListStatus, TravelListAction[]> = {
    quotation_shared: [
        { key: "show_quotation", label: "Show Quotation", icon: "ic-remove_red_eyevisibility" },
        { key: "share_quotation", label: "Share Quotation", icon: "ic-share" },
    ],
    submitted: [
        { key: "generate_qr", label: "Show QR Code", icon: "ic-blur_on" },
        { key: "show_quotation", label: "Show Quotation", icon: "ic-insert_drive_file" },
    ],
    policy_issued: [
        { key: "download_policy", label: "Download Policy", icon: "ic-save_alt" },
    ],
};
